import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { DepartmentModel } from "@/core/models/department.model";

interface _DepartmentGetParams {
    search?: string;
}

@injectable()
export class DepartmentRepo extends TableRepo<DepartmentModel> {
    constructor() {
        super("/api/Department");
    }

    async getData(index: number, params: _DepartmentGetParams, pageSize = 10): Promise<ApiPage<DepartmentModel>|null> {
        return await super.getData(index, params, pageSize);
    }

}